import { createContext, FC, useEffect, useState } from 'react';
import { Lesson } from '../service/lesson-service';
import { setLocalStorage } from '../utils/web-storage-utils';

export type LessonContextProps = {
  lessonId: string;
  companyId: string;
  roomId: string;
  startDatetime: Date;
  endDatetime: Date;
  updateLessonInfo: React.Dispatch<React.SetStateAction<Lesson>>;
};

export const LessonContext = createContext<LessonContextProps>(null as any);

type Props = {
  children: React.ReactNode;
};
const LessonProvider: FC<Props> = ({ children }) => {
  const [lessonInfo, setLessonInfo] = useState<Lesson>(
    (() => {
      return {
        companyId: '',
        lessonId: '',
        roomId: '',
        endDatetime: new Date(),
        startDatetime: new Date()
      };
    })()
  );

  useEffect(() => {
    setLocalStorage('roomId', lessonInfo.roomId);
    setLocalStorage('companyId', lessonInfo.companyId);
  }, [lessonInfo]);

  return (
    <LessonContext.Provider
      value={{
        ...lessonInfo,
        updateLessonInfo: setLessonInfo
      }}
    >
      {children}
    </LessonContext.Provider>
  );
};
export default LessonProvider;
